import { render, staticRenderFns } from "./Identify.vue?vue&type=template&id=84ca672c&"
import script from "./Identify.vue?vue&type=script&lang=js&"
export * from "./Identify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports